import { isPlatformServer } from '@angular/common';
import { Component, DestroyRef, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ContactDialogComponent } from 'src/app/components/contact-dialog/contact-dialog.component';
import { subscriberRoles } from 'src/app/constants/subscriberRoles';
import { Subscription } from 'src/app/models/subscription.model';
import { UserSubscription } from 'src/app/models/userSubscription.model';
import { AuthService } from 'src/app/services/auth.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { isUnderAge } from 'src/app/utilities/underage-check';


@Component({
  selector: 'app-subscription-overview',
  standalone: false,
  templateUrl: './subscription-overview.component.html',
  styleUrl: './subscription-overview.component.scss'
})
export class SubscriptionOverviewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  public subscriptions: Subscription[] = [];
  public activeSubscription: UserSubscription;

  // Default true for safety
  public isUnderAge: boolean = true;
  
  public loading: boolean = true;
  public error: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly subscriptionService: SubscriptionService,
    private readonly dialog: MatDialog,
    private readonly translateService: TranslateService,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {}

    async ngOnInit(): Promise<void> {
     if (isPlatformServer(this._platformId)) {
      return;
    }

    this.loading = true;

    if (this.isLoggedIn()) {
      this.authService.userProfile$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
            if (data && data.birthDay) {
              this.isUnderAge = isUnderAge(data.birthDay);
            }
        });

      this.authService
        .getClaimData(true)
        .then((data) => {
            // data is handled by observable triggers
        })
    }

    await this.loadInit();
    this.loading = false;
  }

  isLoggedIn(): boolean {
    return this.authService.isAuthenticated();
  }

  async loadInit(): Promise<void> {
    try {
      this.subscriptions = await this.subscriptionService.getSubscriptions();

      var activeSubs = await this.subscriptionService.getActiveSubscription(this.authService.authorizationHeaderValue, this.authService.userId);
      
      if(activeSubs) {
        this.activeSubscription = activeSubs;
      } else {
        // Default user sub
        this.activeSubscription = {} as UserSubscription;
        this.activeSubscription.subscription = this.subscriptions.find(
          s => s.name.toLowerCase() === 'user'
        );
      }

      // Clear user out of display
      this.subscriptions = this.subscriptions.filter(s => s.name.toLowerCase() !== "user");
    } catch (error) {
      this.error = true;
      console.error(error);
    }
  }

  openSubscriptionUpgradeContact(): void {
    this.translateService
      .get('subscription.contact_upgrade_title')
      .subscribe((translatedText: string) => {
        this.dialog.open<ContactDialogComponent>(ContactDialogComponent, {
          data: { 
            name: translatedText, 
          },
          autoFocus: false, // To prevent select state of close button in header
        });
      });
    }
}
